import { notification } from "antd";
import { action, makeAutoObservable } from "mobx";
import { Api } from "../../../common/Api";
import { bannersStore } from "./BannersStore";

export class BannerEditStore {
  visible = false;
  loading = false;
  saving = false;
  model: any;

  constructor() {
    makeAutoObservable(this, {});
  }

  @action show(model?) {
    this.model = model;
    this.visible = true;
  }
  @action close() {
    this.visible = false;
  }

  @action save(values: any) {
    this.saving = true;
    const eduShareOffer = { ...this.model.eduShareOffer, ...values?.eduShareOffer };
    return Api.banner
      .saveBanner({ ...this.model, state: "Open", eduShareOffer })
      .then((res) => {
        notification.success({ message: "Success!" });

        setTimeout(() => {
          bannersStore.refresh();
        }, 3000);
        this.visible = false;
      })
      .finally(() => (this.saving = false));
  }
}

export const bannerEditStore = new BannerEditStore();
